"use client";
import { useAuth } from "@/hook/useAuth";
import {
  getEligibilityDetails,
  getFavoritesCards,
} from "@/store/feature/ai-course-finder/aiCourseApi";
import { getCountryList } from "@/store/feature/country/countryApi";
import { getAppliedCourse } from "@/store/feature/courses/courseApi";
import {
  getAppliedApplications,
  getUploadedDocument,
  getUserDetail,
  getUserMeeting,
} from "@/store/feature/user/userApi";
import { useAppDispatch } from "@/store/hooks";
import { useEffect } from "react";

export function CommonApiProvider({ children }: { children: React.ReactNode }) {
  const dispatch = useAppDispatch();
  // const { savedEligibility } = useAppSelector((state) => state.aiCourseFinder);
  const { user, token, isAnonymous } = useAuth();
  // const { countryList } = useAppSelector((state) => state.country);

  useEffect(() => {
    if (token) {
      dispatch(getCountryList());
    }
  }, [dispatch, token]);

  // useEffect(() => {
  //   if (!savedEligibility || Object.keys(savedEligibility).length === 0) return;

  //   if (!countryList || countryList.length === 0) return;

  //   // const savedCountryId = savedEligibility.id;
  //   // if (savedCountryId) {
  //   // 	const matchedCountry = countryList.find(
  //   // 		(item) => Number(item.country_id) === Number(savedCountryId),
  //   // 	);
  //   // 	if (matchedCountry) {
  //   // 		const countryName = matchedCountry.country_name
  //   // 			.toLowerCase()
  //   // 			.includes(" - ")
  //   // 			? matchedCountry.country_name.split(" - ")[1].trim()
  //   // 			: matchedCountry.country_name;
  //   // 		dispatch(setAiCourseFinderCountry(countryName));
  //   // 	}
  //   // }

  //   // dispatch(
  //   //   setAiCourseFinderAcademicDetails({
  //   //     pastQualification: String(savedEligibility.pastQualification || ""),
  //   //     stream: String(savedEligibility.courseStream || ""),
  //   //     passingYear: String(savedEligibility.qualificationYear || ""),
  //   //     gradingSystem: "",
  //   //     pastGrades: convertFromPercentage(
  //   //       String(savedEligibility.pastQualificationPercentage || ""),
  //   //       "Percentage",
  //   //     ),
  //   //     pastMathsGrades: "",
  //   //     pastEnglishGrades: String(savedEligibility.overall || ""),
  //   //     pastChemistryGrades: "",
  //   //     pastPhysicsGrades: "",
  //   //     selectBoard: String(savedEligibility.boardName || ""),
  //   //     board: "",
  //   //   }),
  //   // );

  //   // dispatch(
  //   //   setAiCourseFinderEnglishProficiencyDetails({
  //   //     test: String(savedEligibility.test || ""),
  //   //     listeningScore: String(savedEligibility.listening || ""),
  //   //     readingScore: String(savedEligibility.reading || ""),
  //   //     writingScore: String(savedEligibility.writing || ""),
  //   //     speakingScore: String(savedEligibility.speaking || ""),
  //   //     overallScore: String(savedEligibility.overall || ""),
  //   //     englishMarks: String(savedEligibility.overall || ""),
  //   //     selectBoard: String(savedEligibility.boardName || ""),
  //   //   }),
  //   // );
  // }, [savedEligibility, countryList]);

  useEffect(() => {
    if (!user?.uid || isAnonymous || !token) return;

    dispatch(getUserDetail(user.uid));
    dispatch(getUploadedDocument(user.uid));
    dispatch(getAppliedCourse(user.uid));
    dispatch(getFavoritesCards(user.uid));
    dispatch(getEligibilityDetails(user.uid));
    dispatch(getUserMeeting(user.uid));
    dispatch(getAppliedApplications(user.uid));
  }, [user?.uid, isAnonymous, token, dispatch]);

  return <>{children}</>;
}
